<script setup>
// Menu Meta -> Disparo (id 1 + e-mails MetaAccess): escolhe a caixa WhatsApp
// Cloud num seletor e usa o MESMO formulario da aba Disparos da caixa
// (DisparosPage reusado inteiro), sem precisar ir em Configuracoes -> Caixas.
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import DisparosPage from '../settings/inbox/settingsPage/DisparosPage.vue';

const store = useStore();
const inboxesGetter = useMapGetter('inboxes/getInboxes');

const selectedInboxId = ref('');

const cloudInboxes = computed(() =>
  (inboxesGetter.value || []).filter(
    i =>
      i.channel_type === 'Channel::Whatsapp' &&
      i.provider === 'whatsapp_cloud' &&
      // DESATIVAR CAIXA (v76): fora das funcoes Template/Disparo do menu Meta
      !i.meta_disabled &&
      // v92: caixas OCULTADAS (Configuracoes -> Ocultar) tambem ficam fora
      !i.hidden
  )
);

const selectedInbox = computed(
  () =>
    cloudInboxes.value.find(i => String(i.id) === String(selectedInboxId.value)) ||
    null
);

onMounted(() => {
  store.dispatch('inboxes/get');
});

const selectClass =
  'h-10 rounded-lg border border-n-weak bg-n-alpha-black2 px-3 text-sm text-n-slate-12 outline-none !mb-0 min-w-72';
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-auto bg-n-surface-1 p-8">
    <div class="max-w-7xl w-full mx-auto">
      <div class="mb-6">
        <h1 class="text-heading-1 text-n-slate-12 mb-1">Meta — Disparo</h1>
        <p class="text-n-slate-11 text-sm mb-4">
          Escolha a caixa de entrada e dispare templates sem sair daqui — é o
          mesmo formulário da aba Disparos da caixa.
        </p>
        <select v-model="selectedInboxId" :class="selectClass">
          <option value="" disabled>Selecione a caixa de entrada</option>
          <option v-for="box in cloudInboxes" :key="box.id" :value="box.id">
            {{ box.name }} ({{ box.phone_number }})
          </option>
        </select>
      </div>

      <!-- key troca a instancia inteira ao mudar de caixa (estado limpo) -->
      <DisparosPage
        v-if="selectedInbox"
        :key="selectedInbox.id"
        :inbox="selectedInbox"
        class="!mx-0"
      />
    </div>
  </div>
</template>
